import { FC, useEffect } from 'react';

interface DefaultBehaviorToastProps {
  onClose: () => void;
}

const AUTO_CLOSE_MS = 4000;

// Shown when Reset to Default is pressed on a setting that is already at its default.
const DefaultBehaviorToast: FC<DefaultBehaviorToastProps> = ({ onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, AUTO_CLOSE_MS);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className="settings-toast" role="status" aria-live="polite">
      <img src="assets/icon/settings/info.svg" alt="" className="settings-toast__icon" />
      <div className="settings-toast__text">
        <p className="settings-toast__title">Default behavior</p>
        <p className="settings-toast__message">This setting is set to its default behavior</p>
      </div>
      <button className="settings-toast__close" onClick={onClose} aria-label="Dismiss">
        <img src="assets/icon/settings/close.svg" alt="" />
      </button>
    </div>
  );
};

export default DefaultBehaviorToast;
